import React from 'react';
import { Modal } from 'react-bootstrap-v5';
import { Link } from 'react-router-dom';
import { KTSVG } from 'src/_metronic/helpers';

type Props = {
  show: boolean;
  handleClose: () => void;
  data: any;
};

const StockCodeProductListModal: React.FC<Props> = ({ show, handleClose, data }) => {
  const dissmissLocation = () => {
    handleClose();
  };

  return (
    <Modal className="modal fade" id="kt_modal_select_location" data-backdrop="static" tabIndex={-1} role="dialog" show={show} aria-hidden="true" onHide={dissmissLocation} centered>
      <div className="modal-content">
        <div className="modal-body text-center ">
          <div className="d-flex justify-content-end">
            <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" onClick={dissmissLocation}>
              <KTSVG path="/media/icons/duotone/Navigation/Close.svg" className="svg-icon-2x" />
            </div>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="feather feather-x-circle text-danger">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
          <p className="mt-5 fw-bolder">Bu satıcı stok kodu ürün listesinde mevcuttur.</p>
          <p>
            Ürünü bulmak için{' '}
            <Link
              to={{
                pathname: '/products/my-products',
                state: { vendorStockCode: data },
                search:`vendorStockCode=${data && data}`
              }}
              className="btn btn-link"
            >
              tıklayınız
            </Link>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default StockCodeProductListModal;
